// @flow
export const API_GET: string = 'API_GET';
export const API_GET_ARRAY: string = 'API_GET_ARRAY';
export const API_CREATE: string = 'API_POST';
export const API_UPDATE: string = 'API_UPDATE';
export const API_DELETE: string = 'API_DELETE';
